import languageZh from "@/language/zh"
import languageEn from "@/language/en"
import languageMs from "@/language/ms"
import store from '@/store'
//判断当前的语言环境
let languageKey = ""; //判断语言环境
let languageJson = {};

/**
    * dataLanuageJson 文案对应的code值
    * @param  { String } req 要翻译的编码
**/
var dataLanuageJson = {
    All: "10075",
    ordinary: "10187",
    IMAX: "10188",
    "General stereo": "10189",
    "Gift Vouchers": "10192",
    Contests: "10166",
    Contests: "10166",
    Contests: "10166",
    Contests: "10166",
    "U+Exclusive": "10193",
    "F&B": "10194",
    "movies": "10152",
    partnership: "10164"

}
languageKey = store.state.language || "en";

function optionLangueFun(req) { //切换语言的方法
    switch (req) {
        case 'zh':
            languageJson = languageZh;
            break;
        case 'en':
            languageJson = languageEn;
            break;
        case 'ms':
            languageJson = languageMs;
            break;
    }
}
optionLangueFun(languageKey);

const VueLanguage = {
    install(Vue, instance) {
        /**
            * lanuage 语言包翻译
            * @param  { String } req 要翻译的编码
        **/
        Vue.prototype.lanuage = (req) => {
            if (!req) return "请传入需要翻译的key"
           
            if (languageJson[req]) return store.state.languageJson[req]
            else return "请检查数据词典"
        },
            /**
                 * optionLanuage 语言包切换
                 * @param  { String } req 需要转化的语言 zh:中文 en:英文 ms:马来语
                 * @param  { String } sourceLangue 原始的语言文案 不是必传
             **/
            Vue.prototype.optionLanuage = (req, sourceLangue) => {
                store.commit('memoryData', { language: req });
                optionLangueFun(req);
                store.commit('memoryData', { languageJson })
            },
            /**
               * dataLanuage 更具文案直接翻译成对于的语言
               * @param  { String } req 需要查询的文案
           **/
            Vue.prototype.dataLanuage = (req) => {
                var dataCode = dataLanuageJson[req];
                if (!dataCode) return "请传入需要翻译的key"
                if (languageJson[dataCode]) return store.state.languageJson[dataCode]
                else return "请检查数据词典"
            }
    }
}
export {
    VueLanguage
}


// WEBPACK FOOTER //
// ./src/utils/language.js